import { useState } from 'react'
import { toast } from 'sonner'

interface CopyButtonProps {
  value: string
  label?: string
}

/** Copies `value` to the clipboard, with a brief "Copied" confirmation. */
export function CopyButton({ value, label = 'Copy' }: CopyButtonProps) {
  const [copied, setCopied] = useState(false)

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      toast.error('Could not copy to clipboard')
    }
  }

  return (
    <button
      type="button"
      className="admin-btn admin-btn-sm"
      onClick={handleCopy}
    >
      {copied ? 'Copied' : label}
    </button>
  )
}
